module.exports = __webpack_public_path__ + "img/flower_leaf_28.996a2cdd.png";